import { IBundleUpState } from "./types";

export const initialState: IBundleUpState = {
	endTime: undefined,
	cooldownTime: undefined,
	dip: undefined
};
